<template>
  <div>
    <b-card class="m-3">
      <template #header>
        <h6 class="mb-0 text-center">
          <span class="titulo-sagres font-weight-bold">Lista de vagas</span>
          <b-button class="float-right m-1" size="sm" @click="importarXML()"
            ><font-awesome-icon icon="file-upload" class="mr-2" />Importar XML</b-button
          >
          <b-button class="float-right m-1" size="sm" @click="criarCargo()"
            ><font-awesome-icon icon="plus" class="mr-2" />Nova Vaga</b-button
          >
        </h6>
      </template>
      <b-row class="up-data">
        <b-col cols="8" class=""></b-col>
        <b-col cols="4" class="">
          <b-input-group size="md">
            <b-form-input
              id="filter-input"
              v-model="filter"
              type="search"
              placeholder="Pesquisar"
            ></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        :busy="isBusy"
        :fields="fields"
        :filter="filter"
        :filter-included-fields="filterOn"
        hover
        no-border-collapse
        :items="items"
        :sort-desc="true"
        striped
        small
        :per-page="perPage"
        :current-page="currentPage"
        show-empty
      >
        <template #empty>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #emptyfiltered>
          <span>Não foram encontrados dados.</span>
        </template>
        <template #table-busy>
          <div class="text-center text-dark">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="loading-text">Carregando...</strong>
          </div>
        </template>
        <template v-slot:cell(actions)="row">
          <div v-if="false">
            <span class="">{{}}</span>
          </div>
          <div v-else class="actions-icons">
            <div class="wrapper-icon" @click="verDetalhes(row.item.Id)">
              <font-awesome-icon icon="eye" />
              <div style="font-size: 12px">Detalhar</div>
            </div>
            <div class="wrapper-icon" @click="correcaoDados(row.item.Id)">
              <font-awesome-icon icon="eraser" />
              <div style="font-size: 12px">Correção de Dados</div>
            </div>
            <div class="wrapper-icon" @click="alteracaoNormativa(row.item.Id)">
              <font-awesome-icon icon="edit" />
              <div style="font-size: 12px">Alteração Normativa</div>
            </div>
            <div class="wrapper-icon" @click="abrirModalExclusao(row.item.Id)">
              <font-awesome-icon icon="trash" />
              <div style="font-size: 12px">Excluir</div>
            </div>
          </div>
        </template>
      </b-table>
      <table-pagination :total-rows="items.length" :per-page="perPage" @pageChange="pageChange"></table-pagination>
    </b-card>
    <b-modal 
      id="confirm-delete-modal"
      size="sm"
      button-size="sm"
      centered
      header-bg-variant="secondary"
      header-text-variant="light"
      header-class=""
      footer-class=""
      modal-class="p-2"
      no-close-on-backdrop
      no-close-on-esc
    >
      <template v-slot:modal-header="">
        <h5>Confirmar exclusão</h5>
      </template>
      Tem certeza que deseja excluir a vaga?
      <template v-slot:modal-footer="">
        <b-button size="sm" @click="excluirCargo()">
          Excluir
        </b-button>
        <b-button size="sm" variant="outline-secondary" @click="cancelarExclusao()">
          Cancelar
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import cargoService from "@/services/atos-pessoal/cargoService";
import TablePagination from '@/components/atos-pessoal/TablePagination.vue';

export default {
  name: "consultar-cargo",
  components: {TablePagination},
  data() {
    return {
      tabelasAuxiliares: [],
      perPage: 10,
      currentPage: 1,
      filter: null,
      filterOn: ["Codigo", "Nomenclatura"],
      isBusy: true,
      fields: [
        {
          key: "Id",
          tdClass: "d-none",
          thClass: "d-none",
          sortable: false,
        },
        {
          key: "Codigo",
          label: "Código",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "Nomenclatura",
          label: "Nomenclatura",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "IdTipoVinculo",
          tdClass: "d-none",
          thClass: "d-none",
        },
        {
          key: "DeTipoVinculo",
          label: "Vínculo",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "QuantidadeVagas",
          label: "Quantidade de Vagas",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "IdSituacaoCargoTce",
          label: "Situação no TCE-SE",
          tdClass: "align-middle",
          thClass: "align-center",
          sortable: true,
        },
        {
          key: "actions",
          label: "Ações",
          tdClass: ["align-middle", "col-actions"],
          thClass: "text-center",
          sortable: true,
        },
      ],
      items: [],
      itemToDelete: null,
    };
  },
  methods: {
    pageChange(value) {
      this.currentPage = value;
    },

    criarCargo() {
      this.$router.push("/atos-pessoal/cargos/criar");
    },

    importarXML() {
      this.$router.push("/atos-pessoal/cargos/importar-xml");
    },

    alteracaoNormativa(idCargo) {
      this.$router.push(`/atos-pessoal/cargos/${idCargo}/alteracao-normativa`);
    },

    correcaoDados(idCargo) {
      this.$router.push(`/atos-pessoal/cargos/${idCargo}/correcao-dados`);
    },

    verDetalhes(IdCargo) {
      this.$router.push(`/atos-pessoal/cargos/${IdCargo}`);
    },

    abrirModalExclusao(idCargo) {
      this.itemToDelete = idCargo
      this.$bvModal.show('confirm-delete-modal')
    },

    cancelarExclusao() {
      this.itemToDelete = null
      this.$bvModal.hide('confirm-delete-modal')
    },

    async excluirCargo() {
      const response = await cargoService.deletarCargo(this.itemToDelete);
      if(response && response.status == 200) {
        this.itemToDelete = null
        this.$bvModal.hide('confirm-delete-modal')
        this.$toast.success("Vaga excluída com sucesso");
        await this.loadData();
      }
    },

    async loadData() {
      const response = await cargoService.listarCargos();
      if(response && response.status == 200) {
        this.updateData(response.data);
      }
      else {
        this.$toast.error('Erro ao obter a lista de cargos');
      }
      this.isBusy = false;
    },
    async updateData(data) {
      const response = await cargoService.getTabelasAuxiliares();
      this.tabelasAuxiliares = response.data;
      this.items = data.map((item) => {
        item.IdSituacaoCargoTce = this.formatSituacao(item.IdSituacaoCargoTce);
        item.DeTipoVinculo = this.tabelasAuxiliares.tipoVinculo.find(
          (t) => t.Id == item.IdTipoVinculo
        ).Descricao.toUpperCase();
        item.QuantidadeVagas = this.checkNumeroDeVagas(item.QuantidadeVagas)
        item.Nomenclatura = item.Nomenclatura.toUpperCase()

        return item;
      });
    },
    formatSituacao(idSituacao) {
      switch (idSituacao) {
        case 1:
          return "ENTREGUE";
        case 2:
          return "VALIDADO PELO TCE-SE";
        case 3:
          return "INCONFORMIDADE COM NORMATIVO";
        default:
          return idSituacao;
      }
    },
    checkNumeroDeVagas(value) {
      let min = 1;
      let max = 99999;

      if(value.toString().replace(".","") > max)
        value = max
      
      if(value.toString().replace(".","") < min)
        value = min

      var rx=  /(\d+)(\d{3})/;
      value =  String(value).replace(/^\d+/, function(w){
          while(rx.test(w)){
              w= w.replace(rx, '$1.$2');
          }
          return w;
      });
      return value;
    }
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style>
.col-actions {
  padding: 0.5 0.15rem !important;
}

.wrapper-icon:hover {
  color: rgb(106, 106, 161);
  cursor: pointer;
}

.actions-icons {
  display: inline-flex;
  font-size: 16px;
  flex-wrap: wrap;
  gap: 18px;
}

#novoCargoBtnWrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style> 
